import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import PageHero from "../components/PageHero";

export default function ChildSafety() {
  return (
    <>
      <Helmet>
        <title>Child Safety Standards — Instafrnd</title>
        <meta name="description" content="Instafrnd's Child Safety Standards: our zero-tolerance policy on child sexual abuse and exploitation (CSAE), reporting tools, age requirements, and how to contact us." />
        <link rel="canonical" href="https://instafrnd.com/child-safety" />
        <meta property="og:url" content="https://instafrnd.com/child-safety" />
        <meta property="og:title" content="Child Safety Standards — Instafrnd" />
        <meta property="og:description" content="Our zero-tolerance policy on child sexual abuse and exploitation (CSAE), reporting tools, and age requirements." />
      </Helmet>
      <PageHero
        eyebrow="Child Safety Standards"
        title="Protecting children is our highest priority."
        subtitle="Instafrnd maintains a zero-tolerance policy toward child sexual abuse and exploitation (CSAE)."
      />

      <section className="features">
        <div className="wrap content-narrow prose reveal">
          <p><em>Effective Date: 5 August 2026</em></p>
          <p>
            At Instafrnd, the safety of our community — especially children and young
            people — is our highest priority. We maintain a zero-tolerance policy toward
            child sexual abuse and exploitation (CSAE).
          </p>

          <h3>Our commitment</h3>
          <p>Instafrnd strictly prohibits:</p>
          <ul>
            <li>Child sexual abuse material (CSAM)</li>
            <li>Grooming or exploitation of minors</li>
            <li>Sexualization of children</li>
            <li>Requests for explicit images involving minors</li>
            <li>Human trafficking involving minors</li>
            <li>Any activity that violates applicable child protection laws</li>
          </ul>

          <h3>Safety measures</h3>
          <p>To help protect our community, Instafrnd:</p>
          <ul>
            <li>Allows users to report inappropriate content and accounts.</li>
            <li>Reviews reports promptly.</li>
            <li>Permanently bans accounts that violate our Child Safety Policy.</li>
            <li>Removes illegal content immediately upon discovery.</li>
            <li>Cooperates with law enforcement when legally required.</li>
            <li>Uses moderation tools to detect and prevent abusive behavior.</li>
          </ul>

          <h3>Reporting</h3>
          <p>Users can report:</p>
          <ul>
            <li>User profiles</li>
            <li>Messages</li>
            <li>Voice or video rooms</li>
            <li>Images</li>
            <li>Live streams</li>
          </ul>
          <p>Reports are reviewed by our moderation team as quickly as possible.</p>

          <h3>Age requirement</h3>
          <p>
            Users must be at least 18 years old to create an Instafrnd account. If we
            determine that an account belongs to someone under the minimum age, it will be
            suspended or removed.
          </p>

          <h3>Contact</h3>
          <p>
            For child safety concerns:{" "}
            <a href="mailto:connect@instafrnd.com">connect@instafrnd.com</a><br />
            For legal requests:{" "}
            <a href="mailto:legal@instafrnd.com">legal@instafrnd.com</a>
          </p>

          <h3>Emergency</h3>
          <p>
            If you believe a child is in immediate danger, please contact your local law
            enforcement agency immediately.
          </p>

          <h3>Related policies</h3>
          <p>
            Our child safety practices are also covered in our{" "}
            <Link to="/privacy">Privacy Policy</Link> and Terms of Service. Learn more about
            how we keep everyone safe in our <Link to="/safety">Safety Center</Link>.
          </p>
        </div>
      </section>
    </>
  );
}
